export const ContentBaseTemplateTypeMap = {
    STANDARD: 1,
    CUSTOM: 2,
    BASIC: 3
}

export const ContentBaseTemplateTypeMixin = {
    data() {
        return {
            ContentBaseTemplateTypes: ContentBaseTemplateTypeMap
        };
    }
}